import styled from "styled-components";
import { Container } from "react-bootstrap";
import { colors, types } from "../../libs";

export const StyledContainer = styled(Container)`
  padding-top: 16px;
  max-width: 1111px;
`;
export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;
export const HeaderLeftSection = styled.div`
  ${types.headers.itemMedium};
  display: flex;
  align-items: center;
  gap: 8px;
`;
export const HeaderRightSection = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;
export const Description = styled.p`
  ${types.body.normal};
  color: ${colors.text.gray};
  margin-top: 16px;
`;
export const SearchBarWrapper = styled.div`
  position: relative;
  width: 254px;
`;
export const SearchInput = styled.input`
  width: 100%;
  border-radius: 20px;
  padding: 8px 50px;
  background: ${colors.background.smokyBlack};
  color: ${colors.text.white};
  border: 1px solid rgba(255, 255, 255, 0.2);
  &:focus {
    outline: none;
  }
`;
export const SearchIcon = styled.img`
  position: absolute;
  left: 20px;
  top: 14px;
  z-index: 1;
`;
export const NewButtonContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
`;
export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-top: 24px;
  @media (max-width: 700px) {
    grid-template-columns: 1fr;
  }
`;
export const StatCard = styled.div`
  background: ${colors.background.lightBlack};
  border-radius: 12px;
  padding: 16px;
  border: 1px solid rgba(255, 255, 255, 0.06);
`;
export const StatValue = styled.div`
  color: ${colors.text.white};
  font-size: 24px;
  font-weight: 600;
`;
export const StatLabel = styled.div`
  ${types.body.small};
  color: ${colors.text.gray};
  margin-top: 4px;
`;
export const List = styled.div`
  margin-top: 24px;
`;
export const NoDataWrapper = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;
  color: ${colors.text.gray};
`;
